import { Toaster as SonnerToaster } from "sonner";
import { CheckCircleIcon } from "@phosphor-icons/react/CheckCircle";
import { InfoIcon } from "@phosphor-icons/react/Info";
import { WarningIcon } from "@phosphor-icons/react/Warning";
import { XCircleIcon } from "@phosphor-icons/react/XCircle";
import { Icon } from "../Icons/Icon";
import { Spinner } from "./Spinner";

export function Toaster() {
  return (
    <SonnerToaster
      position="top-center"
      richColors
      closeButton
      icons={{
        success: <Icon icon={CheckCircleIcon} />,
        info: <Icon icon={InfoIcon} />,
        warning: <Icon icon={WarningIcon} />,
        error: <Icon icon={XCircleIcon} />,
        loading: <Spinner size={18} />,
      }}
    />
  );
}
